import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ExternalLink, ShieldCheck } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-[#f1f1f1] border-t border-neutral-900 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
        {/* Brand Column */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3">
            <img
              src="https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/90f5eb87-5ef2-4351-8a0f-2734b57377f4.png"
              alt="Hillerød Smørrebrød Logo"
              className="h-10 w-auto object-contain brightness-0 invert"
            />
          </div>
          <p className="text-sm text-[#f1f1f1]/80 leading-relaxed max-w-sm mt-2">
            Højtbelagt smørrebrød, lækre sandwich og frokostordninger lavet af friske råvarer af højeste kvalitet. Vi leverer direkte til din dør eller virksomhed i Hillerød og omegn.
          </p>
        </div>

        {/* Opening Hours Column */}
        <div className="flex flex-col gap-4">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-[#f1f1f1] border-b border-neutral-900 pb-2">
            Åbningstider
          </h3>
          <ul className="text-sm text-[#f1f1f1]/80 flex flex-col gap-2.5">
            <li className="flex justify-between">
              <span>Mandag - Onsdag:</span>
              <span className="text-[#f1f1f1] font-medium">08:00 - 14:00</span>
            </li>
            <li className="flex justify-between">
              <span>Torsdag - Fredag:</span>
              <span className="text-[#f1f1f1] font-medium">08:00 - 14:00</span>
            </li>
            <li className="flex justify-between">
              <span>Lørdag:</span>
              <span className="text-[#f1f1f1] font-medium">10:00 - 14:00</span>
            </li>
            <li className="flex justify-between">
              <span>Søndag:</span>
              <span className="text-[#f1f1f1]/50">Lukket (Efter aftale)</span>
            </li>
          </ul>
        </div>

        {/* Contact & Info Column */}
        <div className="flex flex-col gap-4">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-[#f1f1f1] border-b border-neutral-900 pb-2">
            Kontakt & Info
          </h3>
          <ul className="text-sm text-[#f1f1f1]/80 flex flex-col gap-3">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-[#f1f1f1]/50 mt-0.5 shrink-0" />
              <a href="tel:48266613" className="text-[#f1f1f1] hover:underline font-medium">
                48 26 66 13
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-[#f1f1f1]/50 mt-0.5 shrink-0" />
              <a href="mailto:kontakt@hilleroedsmoerrebroed.dk" className="text-[#f1f1f1] hover:underline font-medium">
                kontakt@hilleroedsmoerrebroed.dk
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#f1f1f1]/50 mt-0.5 shrink-0" />
              <span className="text-[#f1f1f1] font-medium">
                Frederiksværksgade 63, 3400 Hillerød
              </span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6 pt-8 border-t border-neutral-900 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-[#f1f1f1]/60">
        <div className="flex flex-wrap items-center gap-6">
          <span>&copy; {currentYear} Hillerød Smørrebrød. Alle rettigheder forbeholdes.</span>
          <a
            href="https://www.findsmiley.dk/1447473"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-[#f1f1f1]/80 hover:text-[#f1f1f1] transition-colors"
          >
            <ShieldCheck size={14} className="text-emerald-500" />
            <span>Se Smiley-rapport</span>
            <ExternalLink size={10} />
          </a>
        </div>
        <div className="flex flex-wrap justify-center sm:justify-end gap-x-4 gap-y-2 w-full sm:w-auto">
          <Link to="/" className="hover:text-[#f1f1f1] transition-colors">Forside</Link>
          <Link to="/menukort" className="hover:text-[#f1f1f1] transition-colors">Menukort</Link>
          <Link to="/firmaordning" className="hover:text-[#f1f1f1] transition-colors">Firmaordning</Link>
          <Link to="/om-os" className="hover:text-[#f1f1f1] transition-colors">Om os</Link>
          <Link to="/kontakt" className="hover:text-[#f1f1f1] transition-colors">Kontakt</Link>
        </div>
      </div>
    </footer>
  );
}
